import React, { FC } from 'react';
import { IngkaTooltipProps } from './IngkaTooltipProps';
import Tooltip from '@ingka/tooltip';
import { getIdFromLabel } from '../../utils/utils';

const IngkaTooltip: FC<IngkaTooltipProps> = ({ label, children }) => {
  return (
    <Tooltip tooltipText={label} describedById={getIdFromLabel(label)}>
      {children}
    </Tooltip>
  );
};

export default IngkaTooltip;
